const AUTH_LOCAL_STORAGE_KEY = "cr-auth-key";

const getAuthLocal = () => {
  if (!localStorage) {
    return;
  }

  const lsValue = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY);

  if (!lsValue) {
    return;
  }

  try {
    const auth = JSON.parse(lsValue);
    if (auth) {
      return auth;
    }
  } catch (error) {
    console.error("AUTH LOCAL STORAGE PARSE ERROR", error);
  }
};

const setAuthLocal = (auth) => {
  if (!localStorage) {
    return;
  }

  try {
    const lsValue = JSON.stringify(auth);
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue);
  } catch (error) {
    console.error("AUTH LOCAL STORAGE SAVE ERROR", error);
  }
};

const removeAuthLocal = () => {
  if (!localStorage) {
    return;
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY);
  } catch (error) {
    console.error("AUTH LOCAL STORAGE REMOVE ERROR", error);
  }
};

const setupAxios = (axios, saveAuthData, logout) => {
  axios.defaults.headers.Accept = "application/json";
  axios.interceptors.request.use(
    function (config) {
      const auth = getAuthLocal();
      if (auth && auth.accessToken) {
        config.headers.Authorization = `Bearer ${auth.accessToken}`;
      }
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    async (response) => {
      if (!!response.data?.message && !response.data?.success) {
        if (
          response.data?.message === "jwt expired" ||
          response.data?.message === "jwt malformed" ||
          response.data?.message === "Forbidden"
        ) {
          window.location.href = "/";
          logout();
        }
      }
      return response;
    },
    (err) => Promise.reject(err)
  );
};

export { setupAxios, getAuthLocal, setAuthLocal, removeAuthLocal, AUTH_LOCAL_STORAGE_KEY };
